import OneClickCheckoutContext, {
  OneClickCheckoutInterface,
} from "../contexts/one-click-checkout/context";

import { useContext } from "react";

const useOneClickCheckout = (): OneClickCheckoutInterface =>
  useContext(OneClickCheckoutContext);

export default useOneClickCheckout;
